import * as React from 'react';
import { usePopper } from 'react-popper';
import Icon from '../Icon';

import { Arrow, CloseButton, ContentPopper, DescriptionPopper, Popper, TitlePopper } from './styles';

export default function Popup({ anchorElProp, placement = 'right', title, description, open, closeFunction }) {
  const [referenceElement] = React.useState(anchorElProp);
  const [isOpen, setIsOpen] = React.useState(open);
  const [popperElement, setPopperElement] = React.useState(null);
  const [arrowElement, setArrowElement] = React.useState(null);

  const { styles, attributes, update } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      { 
        name: 'arrow', 
        options: { 
          element: arrowElement 
        } 
      },
      {
        name: 'offset',
        options: {
          offset: [10, 20],
        },
      },
    ],
  });

  const closePopper = async () => {
    setIsOpen(false);
    await update();
    closeFunction();
  }

  return (
    <Popper open={isOpen} ref={setPopperElement} style={styles.popper} {...attributes.popper}>
      <ContentPopper>
        <TitlePopper>
          {title}
        </TitlePopper>
        <DescriptionPopper>
          {description}
        </DescriptionPopper>
      </ContentPopper>
      <div>
        <CloseButton onClick={closePopper}>
          <Icon name="close" />
        </CloseButton>
      </div>
      <Arrow ref={setArrowElement} style={styles.arrow} />
    </Popper>
  );
}
